import { render, staticRenderFns } from "./SkillsListPage.vue?vue&type=template&id=3cddcf5f"
import script from "./SkillsListPage.vue?vue&type=script&lang=js"
export * from "./SkillsListPage.vue?vue&type=script&lang=js"
import style0 from "./SkillsListPage.vue?vue&type=style&index=0&id=3cddcf5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports